import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import NewsList from "./components/NewsList";
import { useNewsData } from "../../lib/useMockData";

export default function News() {
  const { heroData } = useNewsData();
  return (
    <PageLayout>
      <InfoPageHero
        label="NEWS"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="お知らせ"
      />
      <NewsList />
      <InfoPageFinalCTA
        title="最新情報をいち早く受け取りたい方は"
        subtitle="お知らせメールの登録や、SNSフォローもお待ちしております"
        ctas={[
          { label: "お問い合わせ", href: "/contact", type: "primary" },
          { label: "横浜ヘリクルージング", href: "/yokohama", type: "secondary" },
        ]}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
